import { render } from "./vueGraph.vue?vue&type=template&id=634f0d28&scoped=true"
import script from "./vueGraph.vue?vue&type=script&lang=js"
export * from "./vueGraph.vue?vue&type=script&lang=js"

import "./vueGraph.vue?vue&type=style&index=0&id=634f0d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634f0d28"]])

export default __exports__